import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";

function AddPendingfee() {
  const [students, setStudents] = useState([]);
  const [pendingFees, setPendingFees] = useState({});
  const [searchQuery, setSearchQuery] = useState(""); // New state variable for search query
  const [selectedClass, setSelectedClass] = useState(""); // New state variable for selected class
  const [selectedDivision, setSelectedDivision] = useState(""); // New state variable for selected division
  const [classes, setClasses] = useState([]); // New state variable for classes
  const [divisions, setDivisions] = useState([]); // New state variable for divisions
  const language = localStorage.getItem("language");
  const [finYear, setFinYear] = useState('2024-2025');
  const [paidFees, setPaidFees] = useState({}); // New state for paid fees
  const [hostelFees, setHostelFees] = useState({}); // New state for paid fees
  const [IdFees, setIdFees] = useState({}); // New state for paid fees
  const [feeType, setFeeType] = useState("");

  const udiseNumber = localStorage.getItem("udiseNumber");
  const navigate = useNavigate();

  useEffect(() => {
    fetchStudentData();
    fetchPendingFees();
    fetchHostelFees();
    fetchIdFees();
  }, [finYear, udiseNumber]);

  useEffect(() => {
    fetchPaidFees();
  }, [finYear, udiseNumber, feeType]);


  const handleChange2 = (e) => {
    const selectedYear = e.target.value;
    if (selectedYear !== finYear) {
      setFinYear(selectedYear);
      setPendingFees({});
      setPaidFees({})
      setHostelFees({});
      setIdFees({});
    }
  };

  useEffect(() => {
    const fetchDefaultYear = async () => {
      try {
        const db = await openIndexedDB();
        const transaction = db.transaction(['defaultSettings'], 'readonly');
        const objectStore = transaction.objectStore('defaultSettings');
        const request = objectStore.get('defaultSettings');

        request.onsuccess = (event) => {
          const defaultSetting = event.target.result;

          if (defaultSetting) {
            setFinYear(defaultSetting.defaultYear);
          } else {
            console.warn("No default settings found for the key 'defaultSettings'.");
          }
        };

        request.onerror = (event) => {
          console.error("Error fetching default settings:", event.target.error);
        };
      } catch (error) {
        console.error('Error fetching default year:', error);
      }
    };
    fetchDefaultYear();
  }, [udiseNumber]);

  const openIndexedDB = () => {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open('SchoolManagementDB', 1);

      request.onerror = (event) => {
        console.error("IndexedDB error:", event.target.error);
        reject("Error opening IndexedDB");
      };

      request.onsuccess = (event) => {
        resolve(event.target.result);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains('studentData')) {
          db.createObjectStore('studentData', { keyPath: 'id' });
        }
      };
    });
  };


  const fetchStudentData = async () => {
    try {
      const db = await openIndexedDB();
      const transaction = db.transaction(['studentData'], 'readonly');
      const objectStore = transaction.objectStore('studentData');
      const allRecords = objectStore.getAll();

      allRecords.onsuccess = (event) => {
        const data = event.target.result;
        if (data) {

          const filteredData = Object.keys(data)
            .filter(key => data[key] !== null && (data[key].isActive !== false || data[key].isActive === undefined)) // Check if student is active
            .map(key => ({
              ...data[key]
            }));
          setStudents(filteredData);
          // setStudents(data);
          // console.log("data",data);
          // console.log("filteredData",filteredData);

          const uniqueClasses = [
            ...new Set(data.map((student) => student.currentClass)),
          ];
          const filtereduniqueClasses = uniqueClasses.filter(
            (classItem) => classItem !== "" && classItem !== undefined
          );
          setClasses(filtereduniqueClasses);

          // Create an object to store divisions for each class
          const classDivisions = {};

          // Iterate through each class
          filtereduniqueClasses.forEach((className) => {
            // Filter students by class
            const classStudents = data.filter(
              (student) => student.currentClass === className
            );

            // Get unique divisions for the class
            const uniqueDivisions = [
              ...new Set(classStudents.map((student) => student.division)),
            ];
            const filtereduniqueDivisions = uniqueDivisions.filter(
              (divItem) => divItem !== "" && divItem !== undefined
            );

            // Store the divisions in the classDivisions object
            classDivisions[className] = filtereduniqueDivisions;
          });

          // Set the divisions state with the classDivisions object
          setDivisions(classDivisions);
        }
      };

      allRecords.onerror = (event) => {
        console.error('Error fetching student data from IndexedDB:', event.target.error);
      };
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const fetchPendingFees = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/pendingFee/${finYear}.json`
      );
      const data = await response.json();

      // Log the fetched pending fees for debugging
      console.log("Fetched pending fees:", data);

      // Check if data is an object and set the pending fees state
      if (typeof data === "object" && data !== null) {
        setPendingFees(data);
      }
    } catch (error) {
      console.error("Error fetching pending fees:", error);
    }
  };

  const handleFeeChange = (serialNo, value) => {
    if (feeType === "Hostel Fee") {
      setHostelFees((prev) => ({
        ...prev,
        [serialNo]: value,
      }));
    } else if (feeType === "Identity Card Fee") {
      // Handle ID Fees
      setIdFees((prev) => ({
        ...prev,
        [serialNo]: value,
      }));
    } else {
      setPendingFees((prev) => ({
        ...prev,
        [serialNo]: value,
      }));
    }
  };



  const handleUpdateFees = async (serialNo) => {
    try {
      const updatedFee = feeType === "Hostel Fee" ? hostelFees[serialNo] || 0 :
        feeType === "Identity Card Fee" ? IdFees[serialNo] || 0 :
          pendingFees[serialNo] || 0;

      const feePath = feeType === "Hostel Fee"
        ? `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/hostel/${finYear}/${serialNo}.json`
        : feeType === "Identity Card Fee"
          ? `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/IdFees/${finYear}/${serialNo}.json`
          : `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/pendingFee/${finYear}/${serialNo}.json`;


      await fetch(feePath, {
        method: "PUT",
        body: JSON.stringify(updatedFee),
        headers: {
          "Content-Type": "application/json",
        },
      });

      alert(`${feeType} updated successfully!`);
    } catch (error) {
      console.error(`Error updating ${feeType}:`, error);
    }
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase()); // Convert search query to lowercase
  };

  const handleClassChange = (e) => {
    setSelectedClass(e.target.value); // Update selected class
  };

  const handleDivisionChange = (e) => {
    setSelectedDivision(e.target.value); // Update selected division
  };
  const handleBack = () => {
    navigate(-1);
  };


  const fetchPaidFees = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${finYear}.json`
      );
      const data = await response.json();


      // Check if data is an object and filter for pending fees
      if (typeof data === "object" && data !== null) {
        const paidFeesData = {};

        // Iterate through each student's fee data
        Object.entries(data).forEach(([serialNo, feeDetails]) => {
          // Check if feeDetails is an object
          if (typeof feeDetails === "object" && feeDetails !== null) {
            // Get all invoice numbers (keys)
            const invoiceNumbers = Object.keys(feeDetails).filter(key => !isNaN(key));
            console.log('lastInvoiceNo', invoiceNumbers);

            // If there are invoices, find the last one
            if (invoiceNumbers.length > 0) {
              const lastInvoiceNo = Math.max(...invoiceNumbers.map(Number));

              // Check if the last invoice exists
              if (feeDetails[lastInvoiceNo]) {
                const lastInvoice = feeDetails[lastInvoiceNo];
                console.log("feeType", feeType);

                // Check if "Pending Fee" exists in the last invoice
                if (feeType === "Hostel Fee") {
                  if (lastInvoice["Hostel Fee"]) {
                    // Extract the beforePay value and convert it to a number
                    const beforePayValue = parseFloat(lastInvoice["Hostel Fee"].beforePay);
                    paidFeesData[serialNo] = isNaN(beforePayValue) ? 0 : beforePayValue; // Default to 0 if NaN
                  }
                }
                else if (feeType === "Identity Card Fee") {
                  if (lastInvoice["Identity Card Fee"]) {
                    // Extract the beforePay value and convert it to a number
                    const beforePayValue = parseFloat(lastInvoice["Identity Card Fee"].beforePay);
                    paidFeesData[serialNo] = isNaN(beforePayValue) ? 0 : beforePayValue; // Default to 0 if NaN
                  }
                }
                else {
                  if (lastInvoice["Pending Fee"]) {
                    // Extract the beforePay value and convert it to a number
                    const beforePayValue = parseFloat(lastInvoice["Pending Fee"].beforePay);
                    paidFeesData[serialNo] = isNaN(beforePayValue) ? 0 : beforePayValue; // Default to 0 if NaN
                  }
                }

              }
            }
          }
        });
        console.log("paidFeesData", paidFeesData);

        setPaidFees(paidFeesData); // Set the paid fees state with the fetched data
      }
    } catch (error) {
      console.error("Error fetching paid fees:", error);
    }
  };

  const fetchHostelFees = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/hostel/${finYear}.json`
      );
      const data = await response.json();
      if (typeof data === "object" && data !== null) {
        setHostelFees(data);
      }
    } catch (error) {
      console.error("Error fetching hostel fees:", error);
    }
  };
  const fetchIdFees = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/IdFees/${finYear}.json`
      );
      const data = await response.json();
      if (typeof data === "object" && data !== null) {
        setIdFees(data);
      }
    } catch (error) {
      console.error("Error fetching id fees:", error);
    }
  };


  const handleFeeTypeChange = (e) => {
    setFeeType(e.target.value);
  };
  return (
    <div className="main-content-of-page">
      <button
        onClick={handleBack}
        style={{
          backgroundColor: "#FFFFFF",
          color: "black",
          padding: "6px 8px",
          borderRadius: "5px",
          cursor: "pointer",
          border: "1px solid black",
        }}
      >
        <i
          className="fa fa-arrow-left"
          style={{ fontSize: "22px", marginRight: "8px" }}
        ></i>
        Go Back
      </button>
      <h3
        className="text-center my-3"
        style={{ color: "#03365e", fontWeight: "600" }}
      >
        {language === "English" ? "Individual Fee" : "वैयक्तिक शुल्क"}
      </h3>
      <div
        style={{ display: "flex", alignItems: "center", margin: "25px auto" }}
      >
        <label htmlFor="finYear" >{language === "English" ? "Year" : "वर्ष"}:</label>
        <select
          id="finYear"
          value={finYear}
          onChange={handleChange2} style={{ marginRight: "10px", height: "40px", padding: "2px 5px" }}
          required  >
          <option value=""> {language === "English" ? "Select Year " : "वर्ष निवडा"}</option>
          <option value="2019-2020">2019-2020</option>
          <option value="2020-2021">2020-2021</option>
          <option value="2021-2022">2021-2022</option>
          <option value="2022-2023">2022-2023</option>
          <option value="2023-2024">2023-2024</option>
          <option value="2024-2025">2024-2025</option>
          <option value="2025-2026">2025-2026</option>
          <option value="2026-2027">2026-2027</option>
          <option value="2027-2028">2027-2028</option>
          <option value="2028-2029">2028-2029</option>
        </select>

        <label style={{ marginRight: "5px" }}>
          {language === "English" ? "Fee Type" : "फी प्रकार"}:
        </label>
        <select
          value={feeType}
          onChange={handleFeeTypeChange}
          style={{ marginRight: "10px", height: "40px", padding: "2px 5px" }}
        >
          <option value="">Select Fee Types</option>
          <option value="Pending Fee">Pending Fee</option>
          <option value="Hostel Fee">Hostel Fee</option>
          <option value="Identity Card Fee">Identity Card Fee</option>
        </select>

        <label style={{ marginRight: "5px" }}>
          {language === "English" ? "Class:" : "वर्ग:"}
        </label>
        <select
          value={selectedClass}
          onChange={handleClassChange}
          style={{ marginRight: "10px", height: "40px", padding: "2px 5px" }}
        >
          <option value="">All Classes</option>
          {classes.map((cls, index) => (
            <option key={index} value={cls}>
              {cls}
            </option>
          ))}
        </select>
        <label style={{ marginRight: "5px" }}>
          {language === "English" ? "Division" : "तुकडी"}:
        </label>
        <select
          value={selectedDivision}
          onChange={handleDivisionChange}
          style={{ marginRight: "10px", height: "40px", padding: "2px 5px" }}
        >
          <option value="">All Divisions</option>
          {divisions[selectedClass]?.map((div, index) => (
            <option key={index} value={div}>
              {div}
            </option>
          ))}

        </select>
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearch}
          placeholder={
            language === "English"
              ? "Search by name Or Roll No"
              : "नावाने किंवा रोल नंबरने शोधा"
          }

          style={{
            marginLeft: "10px",
            height: "40px",
            padding: "2px 5px",
            borderRadius: "5px",
            border: "1px solid gray",
          }}
        />
      </div>
      <table className="table mb-5">
        <thead>
          <tr>
            <th>{language === "English" ? "Sr. No." : "तुकडी"}</th>
            <th>{language === "English" ? "Name" : "नाव"}</th>
            <th>{language === "English" ? "Class" : "वर्ग"}</th>
            <th>{language === "English" ? "Division" : "तुकडी"}</th>
            <th>{language === "English" ? "Roll No" : "हजेरी क्रमांक"}</th>
            <th> {feeType === "Hostel Fee" ? (language === "English" ? "Hostel Fee" : "वसतिगृह फी") :
              feeType === "Identity Card Fee" ? (language === "English" ? "Identity Card Fee" : "ओळखपत्र फी")
                : (language === "English" ? "Pending Fee" : "थकीत फी")}</th>
            <th>{language === "English" ? "Paid Fee" : " दिलेली फी"}</th>
            <th>{language === "English" ? "Remaining Fee" : "उर्वरित फी"}</th>
            <th>Update</th>
          </tr>
        </thead>
        <tbody>
          {students
            .filter((student) => {
              const name = student.stdName
                ? student.stdName.toLowerCase().trim()
                : "";
              const fatherName = student.stdFather
                ? student.stdFather.toLowerCase()
                : "";
              const surname = student.stdSurname
                ? student.stdSurname.toLowerCase()
                : "";
              const rollNo = student.rollNo ? student.rollNo.toString() : "";
              const matchesClass = selectedClass
                ? student.currentClass === selectedClass
                : true;
              const matchesDivision = selectedDivision
                ? student.division === selectedDivision
                : true;
              const isHosteller = feeType === "Hostel Fee" ? student.isHosteller === "true" : true;

              return (
                (name.includes(searchQuery) ||
                  fatherName.includes(searchQuery) ||
                  surname.includes(searchQuery) ||
                  rollNo.includes(searchQuery)) &&
                matchesClass &&
                matchesDivision &&
                isHosteller &&
                name !== ""
              );
            })
            .map((student, index) => (
              <tr key={student.serialNo}>
                <td>{index + 1}</td>
                <td>
                  {student.stdName} {student.stdFather} {student.stdSurname}
                </td>
                <td>{student.currentClass}</td>
                <td>{student.division}</td>
                <td>{student.rollNo}</td>
                <td>
                  <input
                    type="number"
                    value={feeType === "Hostel Fee" ? hostelFees[student.serialNo] || "" :
                      feeType === "Identity Card Fee" ? IdFees[student.serialNo] || "" :
                        pendingFees[student.serialNo] || ""}
                    onChange={(e) => handleFeeChange(student.serialNo, e.target.value)}
                    placeholder="Enter Fee"
                  />
                </td>
                <td>
                  {feeType === "Hostel Fee" ? (
                    paidFees[student.serialNo] !== undefined
                      ? paidFees[student.serialNo].toFixed(2)
                      : "0.00"
                  ) :

                    feeType === "Identity Card Fee" ? (
                      paidFees[student.serialNo] !== undefined
                        ? paidFees[student.serialNo].toFixed(2)
                        : "0.00"
                    ) :
                      (
                        paidFees[student.serialNo] !== undefined
                          ? paidFees[student.serialNo].toFixed(2)
                          : "0.00"
                      )}
                </td>
                <td>
                  {feeType === "Hostel Fee" ? (
                    hostelFees[student.serialNo] !== undefined && !isNaN(hostelFees[student.serialNo]) ?
                      (
                        (parseFloat(hostelFees[student.serialNo]) || 0) -
                        (paidFees[student.serialNo] !== undefined && !isNaN(paidFees[student.serialNo])
                          ? parseFloat(paidFees[student.serialNo]) || 0
                          : 0)
                      ).toFixed(2)
                      : "0.00"
                  ) :

                    feeType === "Identity Card Fee" ? (
                      IdFees[student.serialNo] !== undefined && !isNaN(IdFees[student.serialNo]) ?
                        (
                          (parseFloat(IdFees[student.serialNo]) || 0) -
                          (paidFees[student.serialNo] !== undefined && !isNaN(paidFees[student.serialNo])
                            ? parseFloat(paidFees[student.serialNo]) || 0
                            : 0)
                        ).toFixed(2)
                        : "0.00"
                    ) :
                      (
                        pendingFees[student.serialNo] !== undefined && !isNaN(pendingFees[student.serialNo]) ?
                          (
                            (parseFloat(pendingFees[student.serialNo]) || 0) -
                            (paidFees[student.serialNo] !== undefined && !isNaN(paidFees[student.serialNo])
                              ? parseFloat(paidFees[student.serialNo]) || 0
                              : 0)
                          ).toFixed(2)
                          : "0.00"
                      )}
                </td>

                <td>
                  <button
                    style={{ padding: "5px 5px", backgroundColor: "#b3890c" }}
                    onClick={() => handleUpdateFees(student.serialNo)}
                  >
                    Update
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default AddPendingfee;